import { cx } from '@emotion/css';
import React, { FC, useEffect, useState } from 'react';

interface MediaDisplayProps {
  mediaUrl: string;
}

export const MediaDisplay: FC<MediaDisplayProps> = ({ mediaUrl }) => {
  const [currentMediaUrl, setCurrentMediaUrl] = useState(mediaUrl);
  const isVideo = mediaUrl.endsWith('.mp4');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const playNextMedia = () => {
      setCurrentMediaUrl(mediaUrl);
    };

    const timeout = setTimeout(playNextMedia, 10000);

    return () => {
      clearTimeout(timeout);
    };
  }, [mediaUrl]);

  const handleMediaLoad = () => {
    setIsLoading(false);
  };

  const mediaClasses = cx('w-full h-48 flex items-center justify-center', {
    'animate-pulse bg-gray-100': isLoading,
    'bg-black': !isLoading,
  });

  const imageStyles: React.CSSProperties = {
    objectFit: 'contain',
    width: '100%',
    height: '100%',
  };

  if (!currentMediaUrl) {
    return null;
  }

  return (
    <div className={mediaClasses}>
      {isVideo ? (
        <video
          className={mediaClasses}
          src={currentMediaUrl}
          loop
          autoPlay
          muted
          onLoadedData={handleMediaLoad}
        >
          Your browser does not support the video tag.
        </video>
      ) : (
        <img
          className={mediaClasses}
          src={currentMediaUrl}
          onLoad={handleMediaLoad}
          style={imageStyles}
        />
      )}
    </div>
  );
};
